<style>
  table tr td {
    text-align: center;
  }
</style>
<script>
  import { getContext } from 'svelte';
  import Button from '../Button/Button.svelte';
  import ContentBox from '../ContentBox/ContentBox.svelte';
  import FixedContent from '../FixedContent/FixedContent.svelte';
  import { getPlayerMatchHistory, getPlayerMatchStats, getPlayerMatchStatsBulk } from '../utils/api.js';

  const state = getContext('state');

  export let playerId;

  let matchData = null;
  let matchDataLoading = false;

  let matchDisplay = [];
  let matchOffset = 0;

  const getMatchStats = async (matchId) => {
    const statsData = await getPlayerMatchStats(matchId);
    return statsData;
  };

  const getMatchStatsBulk = async (matchIds) => {
    const statsData = await getPlayerMatchStatsBulk(matchIds);
    return statsData;
  };

  const getMatchHistory = async (getMore = false) => {
    matchDataLoading = true;
    if (!getMore) {
      matchDisplay = [];
      matchOffset = 0;
    }

    matchData = await getPlayerMatchHistory(playerId, matchOffset);
    matchData = matchData.items;

    const allMatchStats = await getMatchStatsBulk(matchData.map((m) => m.match_id));

    for (let x = 0; x < allMatchStats.length; x++) {
      const singleMatch = await getMatchStats(matchData[x].match_id);

      if (singleMatch && singleMatch.rounds) {
        let team;

        if (checkTeamForPlayer(singleMatch.rounds[0].teams[0])) {
          team = singleMatch.rounds[0].teams[0];
        } else if (checkTeamForPlayer(singleMatch.rounds[0].teams[1])) {
          team = singleMatch.rounds[0].teams[1]
        }

        if (team) {
          const matchObj = {
            started_at: matchData[x].started_at,
            map: singleMatch.rounds[0].round_stats.Map,
            score: singleMatch.rounds[0].round_stats.Score,
            win: team.team_stats['Team Win'],
            players: team.players,
            player: team.players.find((el) => el.player_id === playerId),
          };

          matchDisplay = [...matchDisplay, matchObj];
        }
      }
    }

    $state.data.matchDisplay = matchDisplay;
    matchDataLoading = false;
    matchOffset += 20;
  };

  const checkTeamForPlayer = (team) => {
    if (!team.players) return false;

    return team.players.find((el) => el.player_id === playerId);
  };

  const calcPlayerPosition = (teamData) => {
    const sortedByKills = teamData.sort((a, b) => b.player_stats.Kills - a.player_stats.Kills);
    return sortedByKills.map((el) => el.player_id).indexOf(playerId) + 1;
  };

  const getPositionClass = (pos) => {
    if (pos === 1) return 'text-green-500';
    if (pos === 2 || pos === 3) return 'text-yellow-500';
    return 'text-red-500';
  };

  const getKillsClass = (kills) => {
    if (kills >= 30) return 'text-purple-500';
    if (kills >= 20) return 'text-green-500';
    if (kills >= 15) return 'text-yellow-500';
    return 'text-red-500';
  };

  const getHeadshotClass = (hs) => {
    if (hs >= 60) return 'text-purple-500';
    if (hs >= 50) return 'text-green-500';
    if (hs >= 40) return 'text-yellow-500';
    return 'text-red-500';
  };

  const getKdClass = (kd) => {
    if (kd > 1.5) return 'text-purple-500';
    if (kd > 1.2) return 'text-green-500';
    if (kd > 1) return 'text-yellow-500';
    return 'text-red-500';
  };

  const getMultiKillClass = (val) => {
    if (val > 0) return 'text-purple-500';
  };

  getMatchHistory();
</script>

<!--
<FixedContent>
  <ContentBox>
    <Button text="GET" onClick={getMatchHistory} />
    Get list of all match scoreboard stats
  </ContentBox>
</FixedContent>
-->

{#if matchDataLoading || matchDisplay.length > 0}
  <FixedContent>
  <ContentBox>
    {#if matchDataLoading}Loading...{/if}

    {#if matchDisplay.length > 0}
      <small>* Kill based position in scoreboard</small>
      <br />
      <small><b>Key:</b> <span class="text-purple-500">God mode</span> | <span class="text-green-500">Good</span> | <span class="text-yellow-500">Avg</span> | <span class="text-red-500">Git gud</span></small>
      <br /><br />
      <table class="w-full">
        <tr class="border-b  border-b-black">
          <th>Date </th>
          <th>W/L</th>
          <th>Score</th>
          <th>Map</th>
          <th>Pos. *</th>
          <th>Kills</th>
          <th>Assists</th>
          <th>Deaths</th>
          <th>HS %</th>
          <th>KD</th>
          <th>KR</th>
          <th>MVP</th>
          <th>3x</th>
          <th>4x</th>
          <th>5x</th>
        </tr>
        {#each matchDisplay as match, i}
          <tr class="h-12  text-center {i % 2 ? 'bg-gray-100' : ''}">
            <td>{new Date(match.started_at * 1000).getDate()}/{new Date(match.started_at * 1000).getMonth() + 1}/{new Date(match.started_at * 1000).getFullYear()}</td>
            <td class="{match.win === '1' ? 'text-green-500' : 'text-red-500'}">
              {#if match.win === '1'}W{:else}L{/if}
            </td>
            <td class="{match.win === '1' ? 'text-green-500' : 'text-red-500'}">{match.score}</td>
            <td>{match.map}</td>
            <td class={getPositionClass(calcPlayerPosition(match.players))}>
              {calcPlayerPosition(match.players)}
            </td>
            <td class={getKillsClass(match.player.player_stats.Kills)}>{match.player.player_stats.Kills}</td>
            <td>{match.player.player_stats.Assists}</td>
            <td>{match.player.player_stats.Deaths}</td>
            <td class={getHeadshotClass(match.player.player_stats['Headshots %'])}>{match.player.player_stats['Headshots %']}</td>
            <td class={getKdClass(match.player.player_stats['K/D Ratio'])}>{match.player.player_stats['K/D Ratio']}</td>
            <td>{match.player.player_stats['K/R Ratio']}</td>
            <td>{match.player.player_stats.MVPs}</td>
            <td class={getMultiKillClass(match.player.player_stats['Triple Kills'])}>{match.player.player_stats['Triple Kills']}</td>
            <td class={getMultiKillClass(match.player.player_stats['Quadro Kills'])}>{match.player.player_stats['Quadro Kills']}</td>
            <td class={getMultiKillClass(match.player.player_stats['Penta Kills'])}>{match.player.player_stats['Penta Kills']}</td>
          </tr>
        {/each}
      </table>

      <div class="text-center  my-2">
        <Button text="Get 20 More" onClick={() => getMatchHistory(true)} />
      </div>
    {/if}
  </ContentBox>
  </FixedContent>
{/if}
